<template>
    <Modal :show="modalOpen" :closable="!isLoading" @close="close">
        <div slot="header">
            <div class="modal-header">
                <h5 class="modal-title">{{ ceremony.translated_type }} {{ $t('ceremony.delete_title') }}</h5>
                <button
                    type="button"
                    class="close"
                    @click="close"
                    aria-label="Close"
                >
                    <span aria-hidden="true">×</span>
                </button>
            </div>
        </div>

        <div slot="body">
            {{ $t('ceremony.delete_message', {
                type: ceremony.translated_type.toLowerCase(),
                name: ceremony.name,
            }) }}
        </div>

        <div slot="footer">
            <button type="button" :disabled="isLoading" class="btn btn-danger btn-icon btn-sm" @click="deleteCeremony">
                <icon name="trash" scale="0.8"></icon>
                {{ $t('general.delete') }}
            </button>

            <button type="button" :disabled="isLoading" class="btn btn-secondary btn-sm" data-dismiss="modal" @click="close">
                {{ $t('general.close') }}
            </button>
        </div>
    </Modal>
</template>

<script setup>
    import Modal from '../../components/Modal.vue';
    import { ref } from 'vue';
    import { ipcCall, IpcCall } from '../utils/ipcCall';
    import i18n from "../../utils/locale";
    import { notifyError, notifySuccess } from '../../utils/notify';

    const emit = defineEmits(['close', 'deleted']);
    const props = defineProps({
        ceremony: {
            type: Object,
            required: true,
        },
    });

    const isLoading = ref(false);
    const modalOpen = ref(true);

    async function deleteCeremony() {
        isLoading.value = true;

        try {
            await ipcCall(IpcCall.DeleteCeremony, {
                ceremonyId: props.ceremony.id,
            });

            emit('deleted');
            notifySuccess(i18n.t('ceremony.ceremony_deleted', { type: props.ceremony.translated_type }))
        } catch (exception) {
            if (!exception.response || (exception.response && exception.response.status !== 401)) {
                notifyError(exception, i18n.t('ceremony.cant_delete_ceremony', { type: props.ceremony.translated_type }));
            }
        } finally {
            isLoading.value = false;
        }
    }

    function close() {
        emit('close');
    }
</script>
